<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.fabricExpenseStatus === 'Y'
              ? 'success'
              : row.fabricExpenseStatus === 'S'
              ? 'warning'
              : row.fabricExpenseStatus === 'D' ||
                row.fabricExpenseStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ row.v_fabricExpenseStatus }}
        </el-tag>
      </template>
      <template v-slot:substituteInvoice="{ row }">
        <el-tag
          v-if="row.v_substituteInvoice"
          size="mini"
          :type="row.substituteInvoice === '1' ? 'danger' : 'primary'"
        >
          {{ row.v_substituteInvoice }}
        </el-tag>
      </template>
      <template v-slot:forwardGeneralManager="{ row }">
        <el-tag
          v-if="row.v_forwardGeneralManager"
          size="mini"
          :type="row.forwardGeneralManager === '1' ? 'danger' : 'primary'"
        >
          {{ row.v_forwardGeneralManager }}
        </el-tag>
      </template>
      <template v-slot:businessConsumption="{ row }">
        <el-tag
          v-if="row.v_businessConsumption"
          size="mini"
          :type="row.businessConsumption === '1' ? 'danger' : 'primary'"
        >
          {{ row.v_businessConsumption }}
        </el-tag>
      </template>
      <template v-slot:otherSet="{ row }">
        <el-tag
          v-if="row.v_otherSet"
          size="mini"
          :type="row.otherSet === '1' ? 'danger' : 'primary'"
        >
          {{ row.v_otherSet }}
        </el-tag>
      </template>
      <template v-slot:showAmount="{ row }">
        <span> {{ row.v_currencyAmount }} {{ row.v_currencyUnit }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.fabricExpenseCode },
                  query: { fabricExpenseNo: row.fabricExpenseNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
            v-show="
              row.fabricExpenseStatus === 'N' || row.fabricExpenseStatus === 'R'
            "
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.fabricExpenseCode },
                  query: { fabricExpenseNo: row.fabricExpenseNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="
              row.fabricExpenseStatus === 'N' || row.fabricExpenseStatus === 'R'
            "
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.tips_submit_oa_os_approval') || '提交OA审核'"
            placement="top"
            v-if="allow('T')"
            v-show="
              row.fabricExpenseStatus === 'N' || row.fabricExpenseStatus === 'R'
            "
          >
            <i class="el-icon-s-check tool-btn" @click="oaAudit(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'master-fabricExpense-detail',
        params: { ...params, pageType },
        query,
      })
    },
    del({ fabricExpenseCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .fabricExpenseDelApi({ fabricExpenseCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
    oaAudit({ fabricExpenseCode }) {
      this.$confirm(
        '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        const linkUrl = this.$joinURL(
          `/opview/fabric/expense/${fabricExpenseCode}`,
          {
            joinOrigin: true,
            joinBasePath: false,
          }
        )
        this.loadingOpen()
        this.$api
          .fabricExpenseSubmitOaApplyApi({ fabricExpenseCode, linkUrl })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message:
                this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(
              this.$l('INDEX.tips_submission_failed') || '提交失败！'
            )
          })
      })
    },
  },
}
</script>
